<template>
  <div class="loading" v-if="!isFinish" :style="{background: bgcolor}">
    <svg viewBox="25 25 50 50" class="circular">
      <circle cx="50" cy="50" r="20" fill="none" class="path" />
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    isFinish: {
      default() {
        return true
      },
      required: true
    },
    bgcolor: {
      default(){
        return '#fff'
      },
      required: false,
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/rem.scss';
.loading {
  position: absolute;
  top: rem(60px);
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999999;
}
.circular {
  height: rem(42px);
  width: rem(42px);
  animation: loading-rotate 2s linear infinite;
  margin-top: rem(-60px);
}
.path {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: #409eff;
  stroke-linecap: round;
}
@keyframes loading-rotate {
  100% {
    transform: rotate(1turn);
  }
}
</style>